

export default [
    {
        path: '/meetingDetail',
        name: 'meetingDetail',
        meta: {
            title: '详情'
        },
        component: () => import('@/views/meetingDetail')
    },
    {

        path: '/teamHomePage',
        name: 'teamHomePage',
        meta: {
            title: '团队主页'
        },
        component: () => import('@/views/teamHomePage')
    }
]